/* eslint-disable array-bracket-newline */
/**
 * Implements Payments Saga
 */
import {
  call,
  cancel,
  delay,
  put,
  fork,
  select,
  take,
  takeLatest,
} from 'redux-saga/effects';
import { IProfile, enums } from '@kattana-io/common';
import { LOG_OUT, SET_AUTH } from '../actions/auth';
import { UserAPI } from '../store/createStore';
import { authTokenSelector } from '../selectors/auth';
import {
  START_POLLING_PAYMENT,
  STOP_POLLING_PAYMENT,
  actionResetPricingPlan,
  actionSetPricingPlan,
  actionStopPollingPayment,
} from '../actions/features';

const DELAY = 60000;

function* fetchUserProfile(): any {
  const token = yield select(authTokenSelector);
  const profile: IProfile | null = yield call(UserAPI.fetchProfile, token);

  if (profile?.vip_id === enums.PricingPlan.premium) {
    return profile;
  }
}

function* pollUserProfileApi(): any {
  while (true) {
    const profile = yield call(fetchUserProfile);

    if (profile) {
      yield put(actionSetPricingPlan(profile));
      break; // Exit the loop when we get a success profile.
    }
    console.log('Checking user profile status...');

    yield delay(DELAY); // Wait for 1 minute before the next poll.
  }
}

function* watchForStartPaymentPolling(): any {
  while (yield take(START_POLLING_PAYMENT)) {
    const pollingTask = yield fork(pollUserProfileApi);

    // Wait for stop action and then cancel the polling task
    yield take(STOP_POLLING_PAYMENT);
    console.log('Checking user profile status task was cancelled...');

    yield cancel(pollingTask);
  }
}

function* onAuth(): any {
  yield put(actionStopPollingPayment());

  const token = yield select(authTokenSelector);
  const profile: IProfile | null = yield call(UserAPI.fetchProfile, token);

  if (profile) {
    yield put(actionSetPricingPlan(profile));
  }
}

function* onLogOut(): any {
  yield put(actionStopPollingPayment());
  yield put(actionResetPricingPlan());
}

export default function* paymentSaga() {
  yield takeLatest(SET_AUTH, onAuth);
  yield takeLatest(LOG_OUT, onLogOut);
  yield fork(watchForStartPaymentPolling);
}
